import React, { useState, useEffect } from 'react';
import './Maintenance.css'; // 引入新的CSS文件

function Maintenance() {
    const [glows, setGlows] = useState([]);
    
    // 光晕的数量
    const numberOfGlows = 20;

    useEffect(() => {
        const generatedGlows = [];
        for (let i = 0; i < numberOfGlows; i++) {
            const style = {
                // left: 随机的水平位置 (0% 到 100%)
                left: `${Math.random() * 100}%`,
                
                // width/height
                width: `0px`,
                height: `0px`,

                // animationDuration: 随机的动画时长 (10s 到 20s)，让它们速度不同
                animationDuration: `${Math.random() * 10 + 10}s`,

                // animationDelay: 随机的延迟 (0s 到 10s)，让它们不同时开始
                animationDelay: `${Math.random() * 10}s`,
            };
            generatedGlows.push(style);
        }
        setGlows(generatedGlows);
    }, []); 

    return (
        <div className="maintenance-container" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${process.env.PUBLIC_URL}/resource/tsuinosora1.png)` }}>
            {glows.map((style, index) => (
                <div key={index} className="glow" style={style}></div>
            ))}

            <div className="content">
                <h2>网站维护中</h2>
                <h1 className="site-title">終ノ空</h1>
                <p>Coming Soon...</p>
            </div>
        </div>
    );
}

export default Maintenance;
